const initState = {
  badSerialNumber: false,
  email: null,
  address: null,
  phone: null,
  registerPersonalData: {
    success: null,
    error: null,
    code: null,
    message: null,
  },
  validatePersonalData: {
    success: null,
    error: null,
    code: null,
    message: null,
    token: null,
    person: {
      firstName: null,
      lastName: null,
      maternalLastName: null,
      profession: null,
    },
  },
};

export default initState;
